/**
 * Shared application constants
 */

export const CATEGORIES = ['Politics', 'Entertainment', 'Business', 'Sports', 'Other'];

export const LEADERBOARD_LIMIT = 10;

export const VISIBLE_ITEMS_INCREMENT = 20;
